<template>
  <section>
    <Navbar :data="data" />
    <div class="ukraine-donation-terms">
      <div class="ukraine-donation-terms__razor"></div>
      <div
        class="
          ukraine-donation-terms__box
          animate__animated animate__bounceInUp
        "
      >
        <h2>{{ data.title }}</h2>
        <ol class="ukraine-donation-terms__box--list">
          <li>
            <ul>
              <li v-for="(item, i) in data.one" :key="`item_${i}`">
                {{ item }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.two.text
                }}<a :href="data.two.url" target="_blank">{{
                  data.two.link
                }}</a>
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.three }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.four }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.five }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.six }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.seven }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.eight }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.nine }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                {{ data.ten.one
                }}<a :href="data.market.url" target="_blank">{{
                  data.market.name
                }}</a
                >{{ data.ten.two }}
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <div class="ukraine-donation-terms__footer">
        <img :src="require(`../assets/images/${data.navbar.logo}.png`)" />
        <div class="ukraine-donation-terms__footer--links">
          <a :href="data.conditions.url">{{ data.conditions.link }}</a>
          <a :href="data.privacy.url">{{ data.privacy.link }}</a>
        </div>
        <p>{{ data.copyright }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import Navbar from '../components/Navbar.vue'

export default {
  name: 'UkraineDonationTerms',
  components: {
    Navbar,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.ukraine-donation-terms {
  color: var(--color-charcoal-1);
  padding: 50px 0 0;
  position: relative;
  &__razor {
    background-color: var(--color-orange-1);
    clip-path: polygon(0 0, 100% 0%, 100% 70%, 0% 100%);
    height: 700px;
    margin-top: -50px;
  }
  &__box {
    width: 60%;
    margin: 0 20%;
    background-color: var(--color-white-1);
    padding: 50px 4%;
    margin-top: -650px;
    margin-bottom: 100px;
    -webkit-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
      rgba(17, 17, 26, 0.05) 0px 8px 32px;
    -moz-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
      rgba(17, 17, 26, 0.05) 0px 8px 32px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
      rgba(17, 17, 26, 0.05) 0px 8px 32px;
    border-radius: 30px;
    z-index: 9999;
    h2 {
      text-align: center;
      padding: 0 7%;
    }
    &--list {
      ul {
        list-style: none;
        margin: 20px 0;
      }
    }
    @media (max-width: $tablet) {
      width: 90%;
      margin: 0 5%;
      margin-top: -650px;
      margin-bottom: 100px;
      &--list {
        ul {
          margin: 20px 0;
          padding: 0;
        }
      }
    }
  }
  &__footer {
    background-color: var(--color-orange-1);
    text-align: center;
    padding: 20px;
    img {
      width: 200px;
    }
    &--links {
      a {
        margin: 0 10px;
      }
    }
  }
}
</style>